import { __awaiter, __generator } from "tslib";
import { AppAcquisitionLinkEventOriginator, AppBarEventOriginator, AppBarEventTypes, LaunchTileEventOriginator, } from '@office-start/appbar-events';
export function createNovaEventHandler() {
    return {
        bubble: function (event) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(event.event.originator === LaunchTileEventOriginator ||
                                event.event.originator === AppAcquisitionLinkEventOriginator ||
                                event.event.originator === AppBarEventOriginator)) return [3 /*break*/, 2];
                            return [4 /*yield*/, appBarEventHandler(event)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, Promise.resolve()];
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
function appBarEventHandler(event) {
    return __awaiter(this, void 0, void 0, function () {
        var novaEvent, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    novaEvent = event.event;
                    _a = novaEvent.type;
                    switch (_a) {
                        case AppBarEventTypes.launch: return [3 /*break*/, 1];
                        case AppBarEventTypes.moreInfo: return [3 /*break*/, 3];
                        case AppBarEventTypes.appAcquisitionLinkClick: return [3 /*break*/, 5];
                        case AppBarEventTypes.uninstall: return [3 /*break*/, 7];
                        case AppBarEventTypes.flyoutOpened: return [3 /*break*/, 9];
                        case AppBarEventTypes.renderError: return [3 /*break*/, 11];
                        case AppBarEventTypes.appBarImpression: return [3 /*break*/, 13];
                    }
                    return [3 /*break*/, 15];
                case 1: return [4 /*yield*/, import('./launchEventHandler')];
                case 2:
                    (_b.sent()).launchEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 3: return [4 /*yield*/, import('./moreInfoEventHandler')];
                case 4:
                    (_b.sent()).moreInfoEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 5: return [4 /*yield*/, import('./appAcquisitionLinkClickEventHandler')];
                case 6:
                    (_b.sent()).appAcquisitionLinkClickEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 7: return [4 /*yield*/, import('./uninstallEventHandler')];
                case 8:
                    (_b.sent()).uninstallEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 9: return [4 /*yield*/, import('./flyoutOpenedEventHandler')];
                case 10:
                    (_b.sent()).flyoutOpenedEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 11: return [4 /*yield*/, import('./renderErrorEventHandler')];
                case 12:
                    (_b.sent()).renderErrorEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 13: return [4 /*yield*/, import('./appBarImpressionEventHandler')];
                case 14:
                    (_b.sent()).appBarImpressionEventHandler(novaEvent);
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=NovaEventHandler.js.map